import { PresetVisibility } from '@aibees/shared/definition';
import { useMemo } from 'react';

interface Counts {
  [PresetVisibility.ALL]: number;
  [PresetVisibility.PRIVATE]: number;
  [PresetVisibility.INTERNAL]: number;
}

interface UseLabelsEmptyStateParams {
  counts: Counts;
  filteredItemsLength: number;
  tabValue: PresetVisibility;
  searchValue?: string;
}

export function useLabelsEmptyState({
  counts,
  filteredItemsLength,
  tabValue,
  searchValue,
}: UseLabelsEmptyStateParams) {
  const isEmpty = useMemo(() => {
    const count =
      tabValue === PresetVisibility.ALL
        ? counts[PresetVisibility.ALL]
        : tabValue === PresetVisibility.PRIVATE
        ? counts[PresetVisibility.PRIVATE]
        : counts[PresetVisibility.INTERNAL];
    return count === 0 || filteredItemsLength === 0;
  }, [counts, filteredItemsLength, tabValue]);

  const emptyMessage = useMemo(() => {
    if (searchValue?.trim() === '') {
      return 'No List Here Yet.';
    }
    return 'No Result Found';
  }, [searchValue]);

  return { isEmpty, emptyMessage };
}
